<p-toast key="toastStatus" [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog key="confirmStatus" header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<div class="card" *ngIf='displayState.workingDiv'>
  <div class="card-body">
    <div class="row" >
      <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
    </div>
    <div class="row">
      <div class="col-md-2 offset-5">
        <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
      </div>
    </div>
  </div>
</div>
<!--
<p-toast key="infoStatus" [style]="{marginTop: '80px'}"></p-toast>
<p-toast position="center" key="confStatus" (onClose)="onReject()" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div style="text-align: center">
            <i class="pi pi-exclamation-triangle" style="font-size: 3em"></i>
            <h3>{{message.summary}}</h3>
            <p>{{message.detail}}</p>
        </div>
        <div class="ui-g ui-fluid">
            <div class="ui-g-6">
                <button type="button" pButton (click)="onConfirm()" label="Yes" class="ui-button-success"></button>
            </div>
            <div class="ui-g-6">
                <button type="button" pButton (click)="onReject()" label="No" class="ui-button-secondary"></button>
            </div>
        </div>
    </ng-template>
</p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
-->

<div class="card bg-light" style="margin-top: 10px;">
    <div class="card-body" style="background-color: #e9ecef">
        <p-table [value]="statuses" [scrollable]="true" scrollHeight="176px">
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols">
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-status>
                <tr style="font-size: small">
                    <!--<td><a (click)="selectStatus(status)">{{status.statusDate | date: 'M/d/yyyy'}}</a></td>-->
                    <td *ngIf="allowSave"><button class="btn btn-sm btn-link" (click)="selectStatus(status)">{{status.statusDate | date: 'M/d/yyyy'}}</button></td>
                    <td *ngIf="!allowSave">{{status.statusDate | date: 'M/d/yyyy'}}</td>
                    <td>{{status.status}}</td>
                    <td>{{status.subStatus}}</td>
                    <td>{{status.hearingDate  | date: 'M/d/yyyy'}}</td>
                </tr>
            </ng-template>
        </p-table>
        <div class="row" *ngIf="allowNew">
            <button class="btn btn-link" (click)="newStatus()">New Status</button>
        </div>
    </div>
    <div class="row" *ngIf="isLoading">
        <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner>
        Loading...
    </div>

</div>
<!-- Status div -- adding/editing -->
<div class="row" *ngIf="displayState.statusEntryDiv">
    <div class="col-md-12">
        <br />
        <div class="card card-body">
            <div class="form-row">
                <label for="inputStatusDate" class="col-md-2 col-form-label prd-label">Status Date</label>
                <p-calendar id="inputStatusDate" class="col-md-3" [(ngModel)]="myStatus.statusDate" showButtonBar="true"></p-calendar>
                <label for="selectStatus" class="col-md-2 col-form-label prd-label">Status</label>
                <select class="form-control col-sm-4" id="selectStatus" [(ngModel)]="myStatus.status">
                        <option *ngFor="let anOpt of statusChoiceList">{{anOpt}}</option>
                </select>
            </div>
            <br />
            <div class="form-row">
                <label for="selectSubStatus" class="col-md-2 col-form-label prd-label">Sub-Status</label>
                <select class="form-control col-sm-4" id="selectSubStatus" [(ngModel)]="myStatus.subStatus">
                    <option *ngFor="let anOpt of subStatusChoiceList">{{anOpt}}</option>
                </select>
                <label for="selectHearing" class="col-md-2 col-form-label prd-label">Hearing Dt</label>
                <select class="form-control col-sm-3" id="selectHearing" [(ngModel)]="myStatus.hearingId">
                    <!-- <option *ngFor="let anOpt of hearingDateList" value="{{anOpt.id}}">{{anOpt.hearingDate | date: 'MM/dd/yyyy'}} - {{anOpt.hearingTime}}</option> -->
                  <option *ngFor="let anOpt of hearingDateList" value="{{anOpt.id}}">{{anOpt.hearingDateDesc}}</option>
                </select>
            </div>
            <br />
            <div class="form-row">
                <div class="col-md-7 offset-3">
                    <button class="btn btn-sm btn-success" [disabled]="!allowSave || displayState.saveDisabled==true" (click)="saveStatusEntry()">Save Status</button> &nbsp;
                    <button class="btn btn-sm btn-secondary" (click)="cancelStatusEntry()">Cancel</button> &nbsp;
                    <button class="btn btn-sm btn-warning" [disabled]="!allowDelete" *ngIf="!isNewEntry" (click)="deleteStatus(myStatus)">Delete</button>
                </div>
            </div>
        </div>
        <br />
    </div>
</div>

